// Shared queue config used by the public join page, the staff screen and the TV board.

// Stores that run a multi-floor layout show the Gold/Silver department step.
export const FLOOR_BRANCHES = ["TRUGANINA"];
export const isFloorBranch = (b) => FLOOR_BRANCHES.includes((b || "").toUpperCase());

export const DEPARTMENTS = [
  { key: "GOLD", label: "Gold", floor: "Ground floor" },
  { key: "SILVER", label: "Silver", floor: "First floor" },
  { key: "BULLION", label: "Gold Bullion (Bar/Biscuit)", floor: "Entry" },
];

export const deptLabel = (key) => {
  const d = DEPARTMENTS.find((x) => x.key === (key || "").toUpperCase());
  return d ? `${d.label} · ${d.floor}` : "";
};

// Physical areas at a multi-floor store, each with the counters on it. Drives a per-area TV
// screen: /queue-display/TRUGANINA/ground -> Gold + Gold Bullion; /queue-display/TRUGANINA/entry
// -> Gold Bullion only; /queue-display/TRUGANINA/first -> Silver. (/queue-display/TRUGANINA with
// no area shows all counters.)
export const FLOORS = [
  { key: "GROUND", label: "Ground floor", departments: ["GOLD", "BULLION"] },
  { key: "ENTRY", label: "Entry", departments: ["BULLION"] },
  { key: "FIRST", label: "First floor", departments: ["SILVER"] },
];

export const floorByKey = (key) =>
  FLOORS.find((f) => f.key === (key || "").toUpperCase()) || null;

const REASONS_DEFAULT = ["BUY", "SELL GOLD", "REPAIR", "COLLECTION", "ENQUIRY"];

const REASONS_BY_BRANCH = {
  TRUGANINA: [
    "BUY – GOLD JEWELLERY",
    "BUY – SILVER",
    "SELL GOLD",
    "BUY – GOLD BULLION",
    "BUY – SILVER BULLION",
    "SELL BULLION",
    "REPAIR / ALTERATION",
    "ORDER PICKUP",
    "GOLD LOAN / FINANCE",
    "GENERAL ENQUIRY",
  ],
};

export const reasonsFor = (b) => REASONS_BY_BRANCH[(b || "").toUpperCase()] || REASONS_DEFAULT;

// Truganina runs several counters (Gold on the ground floor; Silver and Gold Bullion on the
// first floor) and each ticket is for ONE counter. These lists say which services each counter
// offers; shared services (repair, pickup, valuation, enquiry) are on more than one.
const FLOOR_SERVICES = {
  GOLD: [
    "BUY – GOLD JEWELLERY",
    "SELL GOLD",
    "GOLD LOAN / FINANCE",
    "REPAIR / ALTERATION",
    "ORDER PICKUP",
    "GENERAL ENQUIRY",
  ],
  SILVER: [
    "BUY – SILVER",
    "REPAIR / ALTERATION",
    "ORDER PICKUP",
    "GENERAL ENQUIRY",
  ],
  BULLION: [
    "BUY – GOLD BULLION",
    "BUY – SILVER BULLION",
    "SELL BULLION",
    "ORDER PICKUP",
    "GENERAL ENQUIRY",
  ],
};

// Services available on a given floor (department). Falls back to the full branch list when
// there is no floor (non-floor branches, or before a floor has been chosen).
export const reasonsForFloor = (b, dept) => {
  const all = reasonsFor(b);
  const allowed = isFloorBranch(b) && dept ? FLOOR_SERVICES[(dept || "").toUpperCase()] : null;
  return allowed ? all.filter((r) => allowed.includes(r)) : all;
};

// Services that are usually quick — staff can clear these fast to shrink the visible line.
export const QUICK_SERVICES = [
  "COLLECTION",
  "ORDER PICKUP",
  "ENQUIRY",
  "GENERAL ENQUIRY",
  "VALUATION / APPRAISAL",
];
export const isQuick = (reason) => QUICK_SERVICES.includes((reason || "").toUpperCase());

// "SELL GOLD" -> "Sell Gold"
export const labelCase = (r) =>
  (r || "").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
